import React, { useEffect, useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { getDeleteTelnetAction, setDeleteTelnetSuccessAction } from "../../../store/reducers/adminClientsSlice";
import { useDispatch } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { useSelector } from "react-redux";

interface DeletePopupProps {
  deleteRec?: string;
  onHide?: () => void;
  deleteModalShow: boolean;
  setDeleteModalShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  clientDetails?: any;
  setIsUpdated?: any;
}

const DeletePopup: React.FC<DeletePopupProps> = ({
  deleteRec,
  onHide,
  deleteModalShow,
  setDeleteModalShow,
  setShowSuccessMessage,
  clientDetails,
  setIsUpdated,
}) => {
  const [isAction, setIsAction] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isClientDeleteError, isClientDeleteSuccess } = useSelector(
    (state: any) => state?.adminClients
  );

  const submitHandler = () => {
    const payload = { tenantId: clientDetails?.client_id };
    dispatch(getDeleteTelnetAction({ ...payload }));
  };

  useEffect(() => {
    if (isClientDeleteError === true) {
      setIsUpdated(false);
    } else {
      setIsUpdated(true);
    }
  }, [isClientDeleteError]);


  useEffect(() => {
    if (isClientDeleteSuccess === true) {
      setDeleteModalShow(false);
      dispatch(setDeleteTelnetSuccessAction(false));
    }
  }, [isClientDeleteSuccess]);

  const closeModel = () => {
    setDeleteModalShow(false);
  };

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={deleteModalShow}
      title={"Confirm Deletion"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
         {isClientDeleteError ? (
            <CustomButton
              variant="outlined"
              title="Close"
              onClick={closeModel}
            />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={onHide} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        {/* <Notification /> */}
        <DialogContentText>
          <>
            {/* <img src={alertIcon} alt="icons" /> */}
            {isClientDeleteError ? (
              <Notification />
            ) : (
              <Alert
                sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
                severity="warning"
              >
                Are you sure you want to delete this client?
              </Alert>
            )}
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default DeletePopup;
